var map = {
	"./BGVD.mp4": 7571,
	"./Contact.mp4": 2626,
	"./Main Video.mp4": 242,
	"./firstbg.mp4": 9873,
	"./main video 1.mp4": 1535,
	"./secSec.mp4": 8458,
	"./secondbg.mp4": 4541,
	"./web.mp4": 6488,
	"./welcome.mp4": 3186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9039;